import { SavedSearch } from '@rygen/rygen-ui/model';

import { ShipmentSearchCriteria } from './ShipmentSearchCriteria';

export class ShipmentSavedSearch extends SavedSearch {
  shipmentSavedSearchType?: boolean = true;
  searchData?: ShipmentSearchCriteria;
  searchColumnKeys: string[] = [];

  constructor(opts?: Partial<ShipmentSavedSearch>) {
    super(opts);

    if (opts?.searchData != null) {
      this.searchData = new ShipmentSearchCriteria(opts.searchData);
    }
    if (opts?.searchColumnKeys != null) {
      this.searchColumnKeys = opts.searchColumnKeys;
    }
  }

  static isShipmentSavedSearch(
    savedSearch: SavedSearch,
  ): savedSearch is ShipmentSavedSearch {
    return 'shipmentSavedSearchType' in savedSearch;
  }
}
